export const AUDIO_CONTEXT_ERROR_CODES = {
  NOT_ALLOWED: "NOT_ALLOWED",
  NOT_FOUND: "NOT_FOUND",
  UNSUPPORTED_BROWSER: "UNSUPPORTED_BROWSER",
  UNSUPPORTED_AUDIO_WORKLET: "UNSUPPORTED_AUDIO_WORKLET",
  RECORDING_START_FAILED: "RECORDING_START_FAILED",
  MIC_ACCESS_ERROR: "MIC_ACCESS_ERROR",
} as const;

export class AudioContextError extends Error {
  code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = "AudioContextError";
    this.code = code;
  }
}
